import { Component, Prop } from '@stencil/core';
import { clearThemeStyles, setThemeStyles } from './uui-theme';

@Component({
  tag: 'uui-holiday-theme',
  shadow: true
})
export class UuiHolidayThemeProvider {
  @Prop() global = true;
  connectedCallback() {
    const css = `
    [data-theme="holiday"],
    :root[data-theme="holiday"],
    :host[data-theme="holiday"] {
      --uui-theme-on-secondary: yellow;
      --uui-theme-secondary: green;
      --uui-theme-secondary-900: green;
      --uui-theme-secondary-800: #5f5;
      --uui-theme-secondary-700: #8f8;
    
      --uui-theme-primary-100: #FFCDD2;
      --uui-theme-primary-200: #EF9A9A;
      --uui-theme-primary-300: #E57373;
      --uui-theme-primary-400: #EF5350;
      --uui-theme-primary-500: #F44336;
      --uui-theme-primary-600: #E53935;
      --uui-theme-primary-700: #D32F2F;
      --uui-theme-primary-800: #C62828;
      --uui-theme-primary-900: #B71C1C;

      --uui-theme-secondary-100: #C8E6C9;
      --uui-theme-secondary-200: #A5D6A7;
      --uui-theme-secondary-300: #81C784;
      --uui-theme-secondary-400: #66BB6A;
      --uui-theme-secondary-500: #4CAF50;
      --uui-theme-secondary-600: #43A047;
      --uui-theme-secondary-700: #388E3C;
      --uui-theme-secondary-800: #2E7D32;
      --uui-theme-secondary-900: #1B5E20;

      --uui-theme-variant-100: #FFCDD2;
      --uui-theme-variant-200: #EF9A9A;
      --uui-theme-variant-300: #E57373;
      --uui-theme-variant-400: #EF5350;
      --uui-theme-variant-500: #D32F2F;
      --uui-theme-variant-600: #E53935;
      --uui-theme-variant-700: #D32F2F;
      --uui-theme-variant-800: #C62828;
      --uui-theme-variant-900: #B71C1C;

      --uui-theme-surface: var(--uui-color-midnight);
      --uui-theme-on-surface: var(--uui-color-frost);

      --uui-theme-on-variant: #ff5;
      --uui-theme-tertiary-700: var(--uui-theme-secondary-300);
      --uui-theme-tertiary-800: var(--uui-theme-secondary-500);
      --uui-theme-surface: var(--uui-theme-secondary-500);
      --uui-theme-background: var(--uui-theme-secondary-700);
    }`;
    const style = document.createElement('style') as HTMLStyleElement;
    style.appendChild(document.createTextNode(css));
    setThemeStyles({
      name: 'holiday',
      themeStyles: [style],
      global: this.global
    });
  }

  disconnectedCallback() {
    clearThemeStyles('holiday');
  }
}
